import * as React from 'react';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';

type WarningItem = {
  programmeName: string;
  clubName: string;
};

type Props = {
  isOpen: boolean;
  items: WarningItem[];
  onConfirm: () => void;
  onClose: () => void;
};

export const ClubProgrammeActivationWarningModal: React.FC<Props> = ({ isOpen, items, onConfirm, onClose }) => {
  if (!isOpen) return null;

  const affectedItems = Array.isArray(items) ? items : [];

  return (
    <SimpleModal
      isOpen={isOpen}
      title="Activate with invites-only warning?"
      onCloseClick={onClose}
      showFooter={false}
      isBodyBold={false}
      customClass="cpProgrammeDialog cpProgrammeActivationWarningDialog"
      bodyClassName="cpProgrammeDialogBody"
      dialogStyle={{ maxWidth: 560 }}
    >
      <div className="cpProgrammeDialogContent">
        <div className="cpProgrammeDialogLead isWarning">
          <span className="cpProgrammeDialogIcon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M12 8.25v4.5" />
              <path d="M12 16.5h.01" />
              <path d="M10.18 4.62 3.3 16.56A2 2 0 0 0 5.03 19.5h13.94a2 2 0 0 0 1.73-2.94L13.82 4.62a2.1 2.1 0 0 0-3.64 0Z" />
            </svg>
          </span>
          <div>
            <strong>Some clubs are not ready for booking</strong>
            <p>
              They use <b>Invites only</b>, but their allowed lists are currently empty.
            </p>
          </div>
        </div>

        <div className="cpProgrammeDialogNotice">
          <strong>What happens if you continue?</strong>
          <p>
            The programme will be activated, but these clubs will stay unavailable for booking until children are added
            to their allowed lists. You can update the lists after activation.
          </p>
          <p>
            To make them bookable first, cancel and switch <b>Invites only</b> off for those clubs, or add children to
            their allowed lists.
          </p>
        </div>

        <section className="cpProgrammeDialogSection" aria-label="Affected clubs">
          <div className="cpProgrammeDialogSectionHeader">
            <strong>Affected clubs</strong>
            <span>{affectedItems.length}</span>
          </div>
          <div className="cpProgrammeAffectedList">
            {affectedItems.map((item, index) => (
              <div className="cpProgrammeAffectedRow" key={`${item.programmeName}-${item.clubName}-${index}`}>
                <div>
                  <strong>{item.clubName}</strong>
                  <span>{item.programmeName}</span>
                </div>
                <span className="cpProgrammeAffectedTag">Invites only</span>
              </div>
            ))}
          </div>
        </section>

        <div className="cpProgrammeDialogActions">
          <button type="button" className="cpProgrammeDialogButton isSecondary" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="cpProgrammeDialogButton isPrimary" onClick={onConfirm}>
            Activate anyway
          </button>
        </div>
      </div>
    </SimpleModal>
  );
};

ClubProgrammeActivationWarningModal.displayName = 'ClubProgrammeActivationWarningModal';
